var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbTestPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.9412,
    y: 2,
    width: 48,
    height: 48,
    rx: 5,
    transform: "rotate(45 35.9412 2)",
    fill: "#00C6A2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 33,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 21H53.0002V53H21.0002V21Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0297 36.0571C27.4751 36.0571 27.0255 35.6076 27.0255 35.0533L27.0255 30.0342H22.0045C21.5755 30.0342 21.1939 29.7618 21.0547 29.3562C20.9154 28.9506 21.0494 28.5014 21.388 28.2381L30.4257 21.2114C30.7883 20.9295 31.2961 20.9295 31.6587 21.2114L40.6965 28.2381C41.0351 28.5014 41.169 28.9506 41.0298 29.3562C40.8906 29.7618 40.509 30.0342 40.08 30.0342H35.059L35.059 35.0533C35.059 35.3195 34.9532 35.5748 34.7649 35.7631C34.5766 35.9513 34.3211 36.0571 34.0548 36.0571H28.0297ZM34.0548 29.0304H40.08L31.0422 22.0038L22.0045 29.0304H28.0297L28.0297 35.0533H34.0548L34.0548 29.0304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.059 44.0875L35.059 39.5704C35.059 38.7388 34.3846 38.0647 33.5527 38.0647H28.5317C27.6998 38.0647 27.0255 38.7388 27.0255 39.5704L27.0255 44.0875H22.5931C21.1204 44.0875 20.5229 45.9825 21.7293 46.8267L30.1627 52.7278C30.7042 53.1067 31.4296 53.0885 31.9513 52.6828L39.5414 46.7817C40.6735 45.9016 40.0508 44.0875 38.6166 44.0875H35.059ZM34.0548 44.5894C34.0548 44.8666 34.2796 45.0913 34.5569 45.0913H38.6166C39.0947 45.0913 39.3022 45.696 38.9248 45.9894L31.3348 51.8905C31.1609 52.0257 30.9191 52.0318 30.7386 51.9055L22.3052 46.0044C21.903 45.723 22.1022 45.0913 22.5931 45.0913H27.5276C27.8049 45.0913 28.0297 44.8666 28.0297 44.5894L28.0296 39.5704C28.0296 39.2932 28.2544 39.0685 28.5317 39.0685H33.5527C33.83 39.0685 34.0548 39.2932 34.0548 39.5704L34.0548 44.5894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0967 33.0456L39.5779 33.0456C38.746 33.0456 38.0716 33.7198 38.0716 34.5514V39.5704C38.0716 40.402 38.746 41.0761 39.5779 41.0761L44.0967 41.0761V44.5679C44.0967 46.0213 45.9531 46.6312 46.8157 45.461L52.7066 37.4693C53.116 36.9139 53.0954 36.1515 52.6567 35.6189L46.7658 28.4684C45.8674 27.378 44.0967 28.013 44.0967 29.4256V33.0456ZM39.5779 34.0494L44.5988 34.0495C44.8761 34.0495 45.1009 33.8247 45.1009 33.5476V29.4256C45.1009 28.9547 45.6911 28.743 45.9906 29.1065L51.8815 36.257C52.0278 36.4346 52.0346 36.6887 51.8982 36.8738L46.0072 44.8656C45.7197 45.2556 45.1009 45.0523 45.1009 44.5679V40.5742C45.1009 40.297 44.8761 40.0723 44.5988 40.0723L39.5779 40.0723C39.3006 40.0723 39.0758 39.8476 39.0758 39.5704V34.5514C39.0758 34.2742 39.3006 34.0494 39.5779 34.0494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1794 28.5285L31.6309 24.5113H30.5584L29.0039 28.5285H29.98L30.2331 27.8479H31.9563L32.2033 28.5285H33.1794ZM31.7213 27.095H30.468L31.0947 25.3665L31.7213 27.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9389 39.209C48.8246 39.209 49.3307 38.7212 49.6199 38.2213L48.8848 37.8659C48.7161 38.1972 48.3546 38.4501 47.9389 38.4501C47.2098 38.4501 46.6796 37.89 46.6796 37.1311C46.6796 36.3723 47.2098 35.8121 47.9389 35.8121C48.3546 35.8121 48.7161 36.0711 48.8848 36.3963L49.6199 36.035C49.3367 35.5351 48.8246 35.0533 47.9389 35.0533C46.7338 35.0533 45.7999 35.8965 45.7999 37.1311C45.7999 38.3658 46.7338 39.209 47.9389 39.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.717 49.7311C32.4822 49.7311 32.8859 49.2493 32.8859 48.647C32.8859 48.1411 32.5425 47.7255 32.1147 47.6593C32.4943 47.581 32.8076 47.2437 32.8076 46.7378C32.8076 46.2017 32.416 45.7139 31.6508 45.7139H29.5359V49.7311H31.717ZM31.464 47.322H30.3915V46.4487H31.464C31.7532 46.4487 31.934 46.6354 31.934 46.8883C31.934 47.1413 31.7532 47.322 31.464 47.322ZM31.4941 48.9903H30.3915V48.0568H31.4941C31.8315 48.0568 32.0123 48.2736 32.0123 48.5265C32.0123 48.8156 31.8195 48.9903 31.4941 48.9903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0674 37.0609C37.0674 37.6153 36.6178 38.0647 36.0632 38.0647C35.5086 38.0647 35.059 37.6153 35.059 37.0609C35.059 36.5065 35.5086 36.0571 36.0632 36.0571C36.6178 36.0571 37.0674 36.5065 37.0674 37.0609Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 65C42 68.3137 39.3137 71 36 71C32.6863 71 30 68.3137 30 65C30 61.6863 32.6863 59 36 59C39.3137 59 42 61.6863 42 65Z",
    fill: "#9088DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 70C38.7614 70 41 67.7614 41 65C41 62.2386 38.7614 60 36 60C33.2386 60 31 62.2386 31 65C31 67.7614 33.2386 70 36 70ZM36 71C39.3137 71 42 68.3137 42 65C42 61.6863 39.3137 59 36 59C32.6863 59 30 61.6863 30 65C30 68.3137 32.6863 71 36 71Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6C42 9.31371 39.3137 12 36 12C32.6863 12 30 9.31371 30 6C30 2.68629 32.6863 0 36 0C39.3137 0 42 2.68629 42 6Z",
    fill: "#9088DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 11C38.7614 11 41 8.76142 41 6C41 3.23858 38.7614 1 36 1C33.2386 1 31 3.23858 31 6C31 8.76142 33.2386 11 36 11ZM36 12C39.3137 12 42 9.31371 42 6C42 2.68629 39.3137 0 36 0C32.6863 0 30 2.68629 30 6C30 9.31371 32.6863 12 36 12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 37C12 40.3137 9.31371 43 6 43C2.68629 43 0 40.3137 0 37C0 33.6863 2.68629 31 6 31C9.31371 31 12 33.6863 12 37Z",
    fill: "#9088DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 42C8.76142 42 11 39.7614 11 37C11 34.2386 8.76142 32 6 32C3.23858 32 1 34.2386 1 37C1 39.7614 3.23858 42 6 42ZM6 43C9.31371 43 12 40.3137 12 37C12 33.6863 9.31371 31 6 31C2.68629 31 0 33.6863 0 37C0 40.3137 2.68629 43 6 43Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71 36C71 39.3137 68.3137 42 65 42C61.6863 42 59 39.3137 59 36C59 32.6863 61.6863 30 65 30C68.3137 30 71 32.6863 71 36Z",
    fill: "#9088DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 41C67.7614 41 70 38.7614 70 36C70 33.2386 67.7614 31 65 31C62.2386 31 60 33.2386 60 36C60 38.7614 62.2386 41 65 41ZM65 42C68.3137 42 71 39.3137 71 36C71 32.6863 68.3137 30 65 30C61.6863 30 59 32.6863 59 36C59 39.3137 61.6863 42 65 42Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbTestPreview);
export default __webpack_public_path__ + "static/media/ABTestPreview.35c86ad4d792ad4f10790321ffbc5738.svg";
export { ForwardRef as ReactComponent };